import { getFormDataCookie } from '../../helpers';

export function saveFormDataToCookie(data = {}) {
	const currentData = getFormDataCookie();
	if (currentData) {
		data = {...JSON.parse(currentData), ...data};
	}

	if (window.modForm.opts.quadLinkParams) {
		data = { ...data, ...window.modForm.opts.quadLinkParams };
	}

	if (Object.keys(data).length) {
		Object.entries(data).forEach(([key, value]) => {
			data[key] = encodeURIComponent(value);
		});
	}

	window.modUtils.setCookie('formData', JSON.stringify(data), 1440);
}
